import React from 'react';
import { string } from 'prop-types';
import { Button, Image } from '@thd-olt-component-react/core-ui';
import styles from './sign-in.module.scss';

const userImageIcon = 'https://assets.thdstatic.com/images/v1/signed-in-icon.svg';

const SignInCardContent = ({ userName, userEmail, schema }) => {
  return (
    <div id={schema} data-automation-id="signinCard">
      <div
        className={`u__medium u--paddingBottom ${styles['sign-in__subheader']}`}
      >
        Sign in again for a faster, personalized shopping experience.
      </div>
      <div className={styles['sign-in__user-name-display']}>
        <Image alt="Signed In Icon" src={userImageIcon} />
        <div className="u--paddingLeft">
          {userName && userName.toLowerCase?.() !== 'self' && (
            <div
              className={`u__bold u__husky u--paddingBottom ${styles['sign-in__capitalize-name']}`}
            >
              {userName}
            </div>
          )}
          {userEmail && <div>{userEmail}</div>}
        </div>
      </div>
      <Button
        role="button"
        tag="a"
        href="/auth/view/signin?redirect=/&ref=null"
      >
        Sign In
      </Button>
    </div>
  );
};

SignInCardContent.propTypes = {
  userName: string,
  userEmail: string,
  schema: string,
};

SignInCardContent.defaultProps = {
  userName: null,
  userEmail: null,
  schema: null,
};

export { SignInCardContent };
